module.exports = __webpack_public_path__ + "img/brightdualscreen_300.b529db4a.png";